/* IntelApps — What customers say (home + reusable) */
import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n.js';
import { TESTIMONIALS } from '../data/testimonials.js';

const ROTATE_MS = 7000;

export default function CustomerTestimonials() {
  const { t } = useI18n();
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % TESTIMONIALS.length), ROTATE_MS);
    return () => clearInterval(id);
  }, []);

  const cur = TESTIMONIALS[idx];

  return (
    <section className="section home-voices" id="testimonials" style={{ paddingTop: 0 }}>
      <div className="container">
        <div className="section-head">
          <div>
            <span className="eyebrow">{t.portfolio.clients.eyebrow}</span>
            <h2>{t.portfolio.clients.title}</h2>
          </div>
          <p>{t.portfolio.clients.description}</p>
        </div>

        <div className="testi home-voices-card">
          <div key={idx} className="home-voices-slide">
            <p className="testi-quote">
              <span className="accent">&ldquo;</span>
              {cur.quote}
              <span className="accent">&rdquo;</span>
            </p>

            <div className="testi-person">
              <img src={cur.img} alt={cur.name} />
              <div>
                <div className="testi-person-name">{cur.name}</div>
                <div className="testi-person-role">{cur.role}</div>
              </div>
            </div>

            <div className="testi-nav" role="tablist" aria-label={t.portfolio.clients.title}>
              {TESTIMONIALS.map((tst, i) => (
                <button
                  key={tst.name}
                  type="button"
                  role="tab"
                  aria-selected={i === idx}
                  className={`testi-dot ${i === idx ? 'active' : ''}`}
                  onClick={() => setIdx(i)}
                />
              ))}
            </div>
          </div>

          <div className="testi-card">
            <div className="testi-card-row">
              <span className="lbl">{t.testimonials.project}</span>
              <span className="val">{cur.project}</span>
            </div>
            <div className="testi-card-row">
              <span className="lbl">{t.testimonials.timeline}</span>
              <span className="val">{cur.timeline}</span>
            </div>
            <div className="testi-card-row">
              <span className="lbl">{t.testimonials.outcome}</span>
              <span className="val green">{cur.result}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
